import React, { useState, useContext, useEffect } from "react";

import ScheduleBooking from "./ScheduleBooking";
import TeleDoctorsList from "./TeleDoctorsList";
import { useTranslation } from "react-i18next";
import AuthContext from "../../store/auth-context";
import BookTeleAppointments from "./BookTeleAppointments";
import RequestCallback from "./RequestCallback";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Link } from "react-router-dom";

function TeleDoctor() {
  const authCtx = useContext(AuthContext);
  const { t } = useTranslation();
  const [selectedProcess, setSelectedProcess] = useState<string>("");
  const [doctorDetails, setDoctorDetails] = useState<any>("");
  const [familyMemberId, setFamilyMemberId] = useState<any>(0);
  const [requestCallbackModel, setRequestCallback] = useState<boolean>(false);
  const [patientName, setPatientName] = useState<string>("");
  const [familyMemberList, setFamilyMemberList] = useState<any>([]);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState<string>("1");
  const [requestCallbackSuccess, setRequestCallbackSuccess] =
    useState<boolean>(false);

  const openMobileMenu = (e: any) => {
    e.preventDefault();

    document.getElementById("leftMenu")?.classList.remove("d-none");
  };

  const handleRequestCalbackClose = () => setRequestCallback(false);

  return (
    <>
      <div className="main-content animate py-4 px-3 px-sm-4 position-relative">
        <div className="d-flex align-items-center mb-3">
          <a
            href="#"
            className="d-inline-block d-sm-none text-dark"
            onClick={(e) => openMobileMenu(e)}
          >
            <i className="material-icons-outlined me-2">menu</i>
          </a>
          <img
            src="../assets/images/tele-title-side-anime.gif"
            alt="tele-image"
            className="d-none d-sm-inline-block img-h-75 me-2 mb-2"
          />
          <h3 className="fs-18-24 fw-bold mt-3"> {t("Teleconsultation")}</h3>
          <div
            className={`${
              authCtx.selectedLanguage === "en" ? "ms-auto" : "mr-auto"
            } mw-90px`}
          >
            <button
              className="btn btn-primary no-focus btn-primary-linear"
              onClick={() => setRequestCallback(true)}
            >
              <i className="fa-solid fa-phone fs-14 mx-2 text-white"></i>
              {t("Request Call Back")}
            </button>
          </div>
        </div>
        <div className="card border-0 rounded-1rem mt-3">
          <div className="card-body p-2">
            <div className="border-6px p-3 rounded-1rem">
              <>
                <div className="icon1-content-wrap" id="icons-id">
                  <div
                    className={`d-flex flex-column justify-content-center align-items-center ib-1 cursor-pointer ${
                      selectedProcess === "" ? "disabled-1" : "icon-bg-success"
                    }`}
                    onClick={(e) => setSelectedProcess("")}
                  >
                    <i
                      className={`fa-solid fa-user fs-18-24 icon1 text-white ${
                        selectedProcess === "" ? "bg-primary" : "bg-success"
                      } `}
                    ></i>
                    <span
                      className={`fs-14 mt-2 ${
                        selectedProcess === "" ? "text-primary" : "text-success"
                      }`}
                    >
                      {t("Select Patient")}
                    </span>
                  </div>
                  <div
                    className={`d-flex flex-column justify-content-center align-items-center ib-1 cursor-pointer ${
                      selectedProcess === ""
                        ? "disabled-1"
                        : selectedProcess === "doctor-selection-completed"
                        ? "icon-bg-success"
                        : ""
                    }`}
                    onClick={(e) =>
                      setSelectedProcess("patient-selection-completed")
                    }
                  >
                    <i
                      className={`fa-solid fa-stethoscope fs-18-24 icon1 text-white ${
                        selectedProcess === ""
                          ? "bg-secondary"
                          : selectedProcess === "doctor-selection-completed"
                          ? "bg-success"
                          : "bg-primary"
                      }`}
                    ></i>
                    <span
                      className={`fs-14 mt-2 ${
                        selectedProcess === ""
                          ? "text-secondary"
                          : selectedProcess === "doctor-selection-completed"
                          ? "text-success"
                          : "text-primary"
                      }`}
                    >
                      {t("Select Doctor")}
                    </span>
                  </div>
                  <div
                    className={`d-flex flex-column justify-content-center align-items-center ib-1 cursor-pointer disabled-1`}
                  >
                    <i
                      className={`fa-solid fa-calendar-check fs-18-24 icon1 text-white ${
                        selectedProcess !== "doctor-selection-completed"
                          ? "bg-secondary"
                          : "bg-primary"
                      }`}
                    ></i>
                    <span
                      className={`fs-14 mt-2 ${
                        selectedProcess !== "doctor-selection-completed"
                          ? "text-secondary"
                          : "text-primary"
                      }`}
                    >
                      {t("Select Slot")}
                    </span>
                  </div>
                </div>
                {selectedProcess === "" && (
                  <ScheduleBooking
                    setSelectedProcess={setSelectedProcess}
                    setFamilyMemberId={setFamilyMemberId}
                    setPatientName={setPatientName}
                    setFamilyMemberList={setFamilyMemberList}
                    setSelectedPaymentMode={setSelectedPaymentMode}
                    selectedPaymentMode={selectedPaymentMode}
                  />
                )}
                {selectedProcess === "patient-selection-completed" && (
                  <TeleDoctorsList
                    setSelectedProcess={setSelectedProcess}
                    setDoctorDetails={setDoctorDetails}
                  />
                )}
                {selectedProcess === "doctor-selection-completed" &&
                  doctorDetails && (
                    <BookTeleAppointments
                      setSelectedProcess={setSelectedProcess}
                      doctorDetails={doctorDetails}
                      familyMemberId={familyMemberId}
                      patientName={patientName}
                      familyMemberList={familyMemberList}
                      selectedPaymentMode={selectedPaymentMode}
                    />
                  )}
              </>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        fullWidth={true}
        maxWidth="sm"
        open={requestCallbackModel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
          {t("Request a Callback")}
          <IconButton
            className="float-end p-1"
            aria-label="close"
            onClick={() => handleRequestCalbackClose()}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <RequestCallback
            handleRequestCalbackClose={handleRequestCalbackClose}
            setRequestCallbackSuccess={setRequestCallbackSuccess}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        fullWidth={true}
        maxWidth="sm"
        open={requestCallbackSuccess}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <div className="modal-body px-4 pt-0 pb-1 text-center">
            <div className="position-relative d-flex justify-content-center align-items-center">
              <img
                src="/assets/images/check-2.png"
                className="my-4"
                style={{ height: 120 }}
                alt="check"
              />
              <img
                src="/assets/images/Animation.gif"
                className="position-absolute"
                style={{ height: 120 }}
                alt="anim"
              />
            </div>

            <h4 className="mb-2 mt-0">
              {t("Your Request has been submitted")}{" "}
            </h4>

            <p className="text-dark mb-0 fw-500 mt-2 fs-14">
              {t("One of our agent will get in touch with you soon")}
            </p>

            <div className="p-4 mt-2">
              <Link
                to="/auth/dashboard"
                className="btn btn-primary no-focus px-5 btn-primary-linear"
              >
                {t("Go to Dashboard")}
              </Link>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default TeleDoctor;
